import { LOGGED_IN, SET_AUTH_TOKEN } from './action-types';

// localStorage — общий для всех вкладок; sessionStorage при новой вкладке пустой
const storedLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn'));
const hasToken = !!localStorage.getItem('token');
const loggedIn = storedLoggedIn ?? hasToken;

const initialState = {
  isLoggedIn: !!loggedIn,
  // Rehydrate synchronously so deep-link/refresh data fetches carry a valid
  // token on first render instead of racing App's setAuthToken effect.
  access_token: localStorage.getItem('token') || ''
};

const loginReducer = (state = initialState, action) => {
  if (action.type === LOGGED_IN) {
    return {
      ...state,
      isLoggedIn: action.payload
    };
  }

  if (action.type === SET_AUTH_TOKEN) {
    return {
      ...state,
      access_token: action.payload
    };
  }

  return state;
};

export default loginReducer;
